<template>
  <coozzy-card
    data-cy="settings-templates-handover-section"
    :data-view-ready="!isBusy"
    :title="$t('message.settings.template.titleHandover')">
    <div>
      <div class="row mt-2">
        <div class="col-12 col-md-2 mb-2 mb-md-0">
          <coozzy-dropdown
            design="green"
            size="sm"
            class="w-100"
            :text="selectedEntriesText">
            <coozzy-dropdown-item
              :disabled="selectedEntries.length === 0"
              @click="selectedEntries.length !== 0 ? openConfirmationModal() : ''">
              {{ $t('message.generic.delete') }}
            </coozzy-dropdown-item>
          </coozzy-dropdown>
        </div>
        <div class="col-12 col-md-2 offset-md-8">
          <coozzy-button
            class="w-100 mb-2"
            design="prop-green"
            @click="createTemplateClicked(null)">
            {{ $t('message.settings.template.createHandoverTemplate') }}
          </coozzy-button>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <b-table
            ref="handoverTemplateTable"
            bordered
            hover
            responsive="true"
            stacked="md"
            selectable
            select-mode="single"
            :busy="isBusy"
            :fields="fields"
            :items="sortedTemplate"
            @row-clicked="onRowClicked">
            <!-- Busy state -->
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <coozzy-spinner />
              </div>
            </template>

            <!-- Headings -->
            <template #head(checkbox)="">
              <coozzy-form-checkbox
                ref="header_checkbox"
                @change="(value) => { handleCheckboxesInsideTable(value) }" />
            </template>
            <template #cell(favorite)="data">
              <coozzy-favorite-icon
                :statefavorite="favoriteTemplate === data.item.id"
                @click="setTemplateFavorite(data.item.id)" />
            </template>
            <template #head(name)>
              {{ $t('message.tableColumnHeadings.template') }}
            </template>
            <template #head(property)>
              {{ $t('message.processHandoverTemplate.properties') }}
            </template>

            <!-- Data -->
            <template #cell(checkbox)="data">
              <!-- data needs to be used in order to work properly -->
              <coozzy-form-checkbox
                :id="'checkItem_' + data.item.id"
                @change="(value) => { itemSelected(data.item.id, value) }" />
            </template>
            <template #cell(name)="data">
              <p class="mb-0">
                {{ data.item.name | displayOptionalValue }}
              </p>
            </template>
            <template #cell(property)="data">
              <p class="mb-0">
                {{ getPropertyName(data.item.templateReferences) }}
              </p>
            </template>
          </b-table>
        </div>
      </div>
    </div>
    <b-modal
      :id="'confirmationModal'"
      ref="confirmationModal"
      no-close-on-backdrop
      hide-footer
      :title="$t('message.processHandoverTemplate.confirmation.titleDeletion')">
      <div class="col p-0">
        <p>{{ $t('message.processHandoverTemplate.confirmation.textDeletion') }}</p>
      </div>
      <div class="col p-0">
        <coozzy-button
          size="small"
          class="mb-0 border"
          design="transparent"
          @click="$bvModal.hide('confirmationModal')">
          {{ $t('message.generic.cancel') }}
        </coozzy-button>
        <coozzy-button
          size="small"
          class="float-right mb-0"
          design="green"
          :disabled="disabledDeleteBtn"
          @click="deleteTemplate()">
          {{ $t('message.generic.delete') }}
        </coozzy-button>
      </div>
    </b-modal>
  </coozzy-card>
</template>

<script>
import CoozzyCard from '../../framework/components/card/CoozzyCard'
import CoozzyFavoriteIcon from '../../framework/components/icons/CoozzyFavoriteIcon'
import HandoverProtocolApi from '../../misc/apis/HandoverProtocolApi'
import CoozzyDropdown from '../../framework/components/dropdown/CoozzyDropdown'
import CoozzyDropdownItem from '../../framework/components/dropdown/CoozzyDropdownItem'
import CoozzyButton from '../../framework/components/button/CoozzyButton'
import CoozzySpinner from '../../framework/components/misc/CoozzySpinner'
import CoozzyFormCheckbox from '../../framework/components/form/checkbox/CoozzyFormCheckbox'
import { routeChecks } from '@/mixins/routeChecks'
import Vue from 'vue'
import { user } from '@/mixins/user'
import { tables } from '@/mixins/tables'

export default {
  name: 'HandoverTemplateSettings',
  components: {
    CoozzyFormCheckbox,
    CoozzySpinner,
    CoozzyButton,
    CoozzyDropdownItem,
    CoozzyDropdown,
    CoozzyCard,
    CoozzyFavoriteIcon
  },
  mixins: [user, tables, routeChecks],
  data() {
    return {
      isBusy: false,
      disabledDeleteBtn: false,
      templates: [],
      selectedEntries: [],
      favoriteTemplate: null,
      fields: [
        {
          key: 'checkbox',
          label: '',
          thClass: 'th-checkbox',
          tdClass: 'align-middle border-right-0 checkbox-cell'
        },
        {
          key: 'favorite',
          label: '',
          thClass: 'th-checkbox align-middle',
          tdClass: 'td-favorite align-middle text-center'
        },
        {
          key: 'name',
          label: this.$t('message.tableColumnHeadings.template'),
          thClass: 'align-middle',
          tdClass: 'align-middle'
        },
        {
          key: 'property',
          label: this.$t('message.processHandoverTemplate.properties'),
          thClass: 'align-middle',
          tdClass: 'align-middle'
        }
      ]
    }
  },
  computed: {
    selectedEntriesText() {
      return this.$t('message.generic.selectedEntries') + ':  ' + this.selectedEntries.length
    },
    sortedTemplate() {
      return this.templates.slice().sort((a, b) => {
        // Always put the active favoriteTemplate first
        if (a.id === this.favoriteTemplate) return -1
        if (b.id === this.favoriteTemplate) return 1

        // Then prioritize other favorites
        if (a.favorite === true && b.favorite === false) return -1
        if (a.favorite === false && b.favorite === true) return 1

        // Finally, sort alphabetically by name
        if (a.name > b.name) return 1
        if (b.name > a.name) return -1
        return 0
      })
    }
  },
  mounted: function () {
    this.handoverListTemplates(this.accountId)
  },
  methods: {
    getTemplateFavorite(id) {
      return this.templateFavorite === id
    },
    // to set the template as favorite we must unset the favorite from the other templates
    setTemplateFavorite(id) {
      this.templates.forEach(template => {
        if (template.favorite === true && template.id !== id) {
          HandoverProtocolApi.setFavoriteTemplate(template.id, false)
            .then(() => {
              template.favorite = false
            })
            .catch(() => {
              Vue.toasted.show(this.$t('message.savingErrors.favorite'), { type: 'error' })
            })
        }
      })
      HandoverProtocolApi.setFavoriteTemplate(id, true)
        .then(() => {
          this.favoriteTemplate = id
          this.templates.find(template => template.id === id).favorite = true
        })
        .catch(() => {
          Vue.toasted.show(this.$t('message.savingErrors.favorite'), { type: 'error' })
        })
    },
    handoverListTemplates(accountId) {
      this.isBusy = true
      HandoverProtocolApi.handoverListTemplates(accountId)
        .then(response => {
          this.templates = response.templates
          this.favoriteTemplate = this.templates.find(template => template.favorite === true)?.id
          this.isBusy = false
        })
        .catch(e => {
          this.isBusy = false
          console.log(e)
          Vue.toasted.show(this.$t('message.loadErrors.template'), { type: 'error' })
        })
    },
    getPropertyName(properties) {
      if (properties && properties.length > 0) {
        return properties.map(property => property.propertyName).join(', ')
      }
      return '-'
    },
    onRowClicked(item, index, event) {
      if (
          (event.srcElement.farthestViewportElement && (event.srcElement.farthestViewportElement.classList.contains('td-favorite') || event.srcElement.farthestViewportElement.classList.contains('fa-star'))) ||
          event.srcElement.classList.contains('fa-star') ||
          event.srcElement.classList.contains('td-favorite')) {
          this.setTemplateFavorite(item.id)
        } else if (event.srcElement.classList.contains('custom-checkbox') || event.srcElement.classList.contains('checkbox-cell')) {
        this.itemSelected(item.id, !document.getElementById('checkItem_' + item.id).checked)
        document.getElementById('checkItem_' + item.id).checked = !document.getElementById('checkItem_' + item.id).checked
      } else {
        this.createTemplateClicked(item, index, event)
      }
    },
    createTemplateClicked(template = null) {
      // go to template creation page
      if (template) {
        if (this.isOwnerModule) {
          this.$router.push({ name: 'OwnerHandoverTemplateEditing', params: { id: template.id } }, () => {})
        } else if (this.isAdminModule) {
          this.$router.push({ name: 'AdminHandoverTemplateEditing', params: { id: template.id } }, () => {})
        } else if (this.isAssetModule) {
          this.$router.push({ name: 'AssetHandoverTemplateEditing', params: { id: template.id } }, () => {})
        } else if (this.isAccountingModule) {
          this.$router.push({ name: 'AccountingHandoverTemplateEditing', params: { id: template.id } }, () => {})
        } else {
          this.$router.push({ name: 'MarketingHandoverTemplateEditing', params: { id: template.id } }, () => {})
        }
      } else {
        if (this.isOwnerModule) {
          this.$router.push({ name: 'OwnerHandoverTemplateCreation' }, () => {})
        } else if (this.isAdminModule) {
          this.$router.push({ name: 'AdminHandoverTemplateCreation' }, () => {})
        } else if (this.isAssetModule) {
          this.$router.push({ name: 'AssetHandoverTemplateCreation' }, () => {})
        } else if (this.isAccountingModule) {
          this.$router.push({ name: 'AccountingHandoverTemplateCreation' }, () => {})
        } else {
          this.$router.push({ name: 'MarketingHandoverTemplateCreation' }, () => {})
        }
      }
    },
    openConfirmationModal() {
      this.$refs.confirmationModal.show()
    },
    deleteTemplate() {
      this.disabledDeleteBtn = true
      HandoverProtocolApi.handoverDeleteTemplates(this.selectedEntries)
        .then(() => {
          this.$refs.confirmationModal.hide()
          this.disabledDeleteBtn = false
          // Reload the templates
          this.handoverListTemplates(this.accountId)
          this.selectedEntries = []
          this.$refs.header_checkbox.checked = false
          this.handleCheckboxesInsideTable(false)
          Vue.toasted.show(this.$t('message.settings.template.templateDeletedSuccessfully'), { type: 'success' })
        })
        .catch(e => {
          this.loading = false
          console.log(e)
          Vue.toasted.show(this.$t('message.deleteErrors.template'), { type: 'error' })
        })
    },
    itemSelected(id, checked) {
      if (checked && !this.selectedEntries.includes(id)) {
        this.selectedEntries.push(id)
      } else {
        this.selectedEntries = this.selectedEntries.filter(entry => entry !== id)
      }
    },
    handleCheckboxesInsideTable(value) {
      const allCheckboxesComponents = this.$refs.handoverTemplateTable.$children[1].$children
      this.handleCheckbox(allCheckboxesComponents, value)
    }
  }
}
</script>

<style lang="scss" scoped>
  :deep(.td-message), .th-message {
    width: 34vw;

    p {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 34vw;
    }
  }
</style>
